export const Footer = () => (
  <footer className="border-t border-border mt-10 py-5 px-4" data-testid="app-footer">
    <p className="max-w-7xl mx-auto text-center text-[11px] leading-relaxed text-muted-foreground">
      © 2026 Aabasoft. All Rights Reserved. | ABS Pulse — Proprietary &amp; Confidential | Unauthorized copying, sharing, reproduction, or use is prohibited.
    </p>
  </footer>
);

export default Footer;
